import { useLocation } from "react-router";

import { APP_BASE_HREF } from "../App";

export function useBreadcrumbs(initialTitle?: string) {
  // Split the currentRelativeUrl on /.
  const initial = [
    {
      url: APP_BASE_HREF + "/",
      title: initialTitle ?? "Rana HCC",
    },
  ];

  const currentPath = useLocation().pathname.slice(1); // Remove initial /

  if (currentPath) {
    let splitPathnames: string[] = currentPath.split("/").slice(1);
    if (splitPathnames[0] === APP_BASE_HREF) {
      splitPathnames = splitPathnames.slice(1);
    }
    if (splitPathnames[splitPathnames.length - 1] === "") {
      splitPathnames = splitPathnames.slice(0, -1);
    }

    return initial.concat(
      splitPathnames.map((part, idx) => {
        const url: string = APP_BASE_HREF + "/" + splitPathnames.slice(0, idx + 1).join("/");

        const title = part.replace(/[-_]/g, " ");

        return {
          url,
          title,
        };
      })
    );
  } else {
    return initial;
  }
}
